import "react-app-polyfill/stable";

import React from "react";
import axios from "axios";

// Extract erpId from URL query parameters if present and store it globally in this frame
const urlParams = new URLSearchParams(window.location.search);
const urlErpId = urlParams.get("erpId");
if (urlErpId) {
  window.__frameErpId = parseInt(urlErpId, 10);
}

// Global Axios interceptor to append the X-Erp-Id header if set
axios.interceptors.request.use(
  (config) => {
    if (window.__frameErpId) {
      config.headers["X-Erp-Id"] = window.__frameErpId;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "chart.js/auto";

import App from "./App";
import reportWebVitals from "./utils/reportWebVitals";
import { ThemeProvider } from "./contexts/ThemeContext";
import './syncfusion-license'; // Assurez-vous d'importer ce fichier ici.

// Note: Remove the following line if you want to disable the API mocks.
import "./mocks";

import "animate.css/animate.min.css";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <BrowserRouter>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
